import { Typography } from '@snack-uikit/typography';

import s from './ProductsCatalog.module.scss';

export function NotFound() {
  return (
    <div>
      <Typography
        className={s.notFoundTitle}
        family="sans"
        purpose="title"
        size="l"
        tag="h3"
      >
        По вашему запросу ничего не найдено.
      </Typography>
      <Typography
        className={s.notFoundDescription}
        family="sans"
        purpose="body"
        size="l"
        tag="p"
      >
        Пожалуйста, проверьте правильность написания или попробуйте другие
        ключевые слова.
      </Typography>
    </div>
  );
}
